/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import APIRequest from "./index";
import _ from 'lodash';

export function getBills(df, dt, callback) {
  return APIRequest(
    'get',
    '/accounting/bills',
    {
      df: df,
      dt: dt,
      pageSize: 1000
    },
    {},
    callback);
}

export function getBill(id, callback) {
  return APIRequest('get', `/accounting/bills/${id}`, {}, {}, callback);
}

export function getCdrs(bill, args, callback) {
  args = args || {};
  args.bill = bill;
  return APIRequest('get', '/accounting/cdrs', args, {}, callback);
}

export function createCharge(
  product,
  method,
  amount,
  plan,
  callback,
) {
  return APIRequest(
    'post',
    '/charging/',
    {},
    {
      product,
      method,
      amount,
      plan,
    },
    callback,
  );
}

export function getUserPlan(callback) {
  return APIRequest('get', '/accounting/plan', {}, {}, callback);
}

export function getAvailablePlans(callback) {
  return APIRequest('get', '/accounting/availableplans', {}, {}, callback);
}

export function applyAcctCode(acctCode, callback) {
  return APIRequest('post', '/org/acctcode/apply', {acctcode: acctCode}, {}, callback);
}

export function getBillingInfo() {
  const orgBasic = APIRequest('get', '/org/basic', {}, {});
  const accountBasic = APIRequest('get', '/account/basic', {}, {});
  const plan = APIRequest('get', '/accounting/plan', {}, {});
  return new Promise((resolve, reject) => {
    Promise.all([orgBasic, accountBasic, plan]).then((resps) => {
      const [ob, ab, p] = resps;
      const result = {
        nick: ab.body.name,
        email: ob.body.email,
        balance: _.round(ob.body.balance, 2),
        expired: !_.isNil(p.body.svcExpire) && p.body.svcExpire < 0.001,
        remaining: _.isNil(p.body.svcExpire) ? 0 : _.ceil(p.body.svcExpire),
        tier: p.body.tier,
        billday: p.body.billday,
        lrnodenum: ob.body.lrnodenum,
      };
      resolve(result);
    }).catch((reason) => {
      reject(reason);
    });
  });
}
export function rechgCard(id) {
  return APIRequest('post', `/account/rechgcard/${id}/apply`, {}, {});
}




// WEBPACK FOOTER //
// ./src/api/Billing.js